.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.loading-spinner-container.small {
  padding: 20px;
}

.loading-spinner-container.large {
  padding: 60px 20px;
}

.loading-spinner {
  position: relative;
  width: 50px;
  height: 50px;
}

.loading-spinner-container.small .loading-spinner {
  width: 30px;
  height: 30px;
}

.loading-spinner-container.large .loading-spinner {
  width: 70px;
  height: 70px;
}

.spinner-circle {
  width: 100%;
  height: 100%;
  border: 4px solid #e3e9ee;
  border-top-color: #355980;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-sizing: border-box;
}

.loading-spinner-container.small .spinner-circle {
  border-width: 3px;
}

.loading-spinner-container.large .spinner-circle {
  border-width: 5px;
}

.loading-message {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  text-align: center;
}

.loading-spinner-container.small .loading-message {
  font-size: 14px;
  margin-top: 10px;
}

.loading-spinner-container.large .loading-message {
  font-size: 18px;
  margin-top: 30px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Мобильные устройства */
@media (max-width: 768px) {
  .loading-spinner-container {
    padding: 30px 15px;
  }

  .loading-message {
    font-size: 14px;
  }
}

